"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var G = require("@antv/g");
var _ = require("@antv/util");
var dir_mapper = {
    right: 90 * Math.PI / 180,
    left: (360 - 90) * Math.PI / 180,
    up: 0,
    down: 180 * Math.PI / 180,
};
var Arrow = /** @class */ (function () {
    function Arrow(cfg) {
        this.width = 10;
        this.height = 10;
        this.direction = 'right';
        _.assign(this, cfg);
        this._init();
    }
    Arrow.prototype._init = function () {
        var centerX = this.width / 2;
        var centerY = this.height / 2;
        var points = [
            { x: 0, y: -centerY },
            { x: -centerX, y: centerY },
            { x: centerX, y: centerY },
        ];
        this.shape = new G.Path({
            attrs: _.deepMix({
                path: [
                    ['M', points[0].x, points[0].y],
                    ['L', points[1].x, points[1].y],
                    ['L', points[2].x, points[2].y],
                    ['Z'],
                ],
            }, this.attrs),
        });
        var transformMatrix = [];
        /** rotate */
        transformMatrix.push(['r', dir_mapper[this.direction]]);
        /** transform */
        transformMatrix.push(['t', this.x, this.y]);
        this.shape.transform(transformMatrix);
    };
    return Arrow;
}());
exports.default = Arrow;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/component/lib/legend/category/arrow/index.js
// module id = 777
// module chunks = 37